export default __webpack_public_path__ + "static/amazon-1c3e8fd71696ab6a265053de5381ae67.svg";